import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import HeaderWithoutMenu from '../components/common/landingPage/HeaderWithoutMenu';
import Footer from '../components/common/landingPage/Footer';
import FaqItem from '../components/common/landingPage/FaqItem';
import WhatsApp from '../components/common/landingPage/WhatsApp';

import FaqImage from '../assets/images/landing-page/faq.jpg';

const Faqs = [
  {
    question: '¿Qué es Flowex Pay y que servicios ofrece?',
    answer:
      ' Flowex Pay es una plataforma colombiana creada por Loaded Colombia SAS que hace que enviar dinero al mundo sea fácil, rápido y seguro. Ayudamos a personas y empresas a enviar dinero desde Colombia a países como Estados Unidos, Europa (España, Francia, Alemania), México, China y Canadá, y a tener cuentas virtuales para pagar o recibir dinero como si estuvieran allá.',
  },
  {
    question: '¿Por qué elegir Flowex Pay?',
    answer:
      'Somos más rápidos y económicos que los bancos, ofrecemos cuentas virtuales en EE. UU., Europa y México, y usamos socios seguros como Amazon, Fireblocks y Twilio. También puedes ganar recompensas (no garantizadas) si eliges prestar tus dólares.',
  },
  {
    question: '¿Cómo empiezo a usar Flowex Pay?',
    answer:
      'Regístrate en flowexpay.com, verifica tu identidad y recarga tu cuenta con pesos colombianos vía PSE o desde bancos en EE. UU., Europa o México.',
  },
  {
    question: 'No he recibido el código de verificación',
    answer:
      'Asegúrate de que el número esté correcto (+57 para Colombia). Espera 5 minutos y solicita otro código. Si no llega, contáctame por WhatsApp y lo resolveremos.',
  },
  {
    question: '¿Cómo recargo mi cuenta?',
    answer:
      'Puedes recargar con pesos colombianos vía PSE, o con dólares desde bancos en EE. UU., Europa o México. También aceptamos recargas desde blockchain (costo del 0.3% del monto). Ve a "Recargar" y elige tu método.',
  },
  {
    question: '¿Por qué no veo mi cuenta virtual?',
    answer:
      'Las cuentas virtuales no se crean automáticamente. Si necesitas una, nosotros la solicitamos por ti con socios como Lead Bank en EE. UU. Escríbeme y te ayudo a gestionarla.',
  },
  {
    question: '¿Cuál es la misión de Flowex Pay?',
    answer:
      'Nuestra misión es hacer que el dinero fluya sin fronteras, ayudando a nuestros clientes a no preocuparse por la devaluación del peso o los altos costos de los bancos. Queremos que enviar dinero al mundo sea fácil y accesible para todos.',
  },
  {
    question: '¿Por qué debería elegir Flowex Pay?',
    answer:
      'Somos más rápidos y económicos que los bancos, ofrecemos cuentas virtuales en EE. UU., Europa y México, y usamos socios seguros como Amazon, Fireblocks y Twilio para proteger tus datos y fondos. También puedes ganar recompensas (no garantizadas) si eliges prestar tus dólares.',
  },
  {
    question: '¿Qué tan rápido puedo enviar dinero?',
    answer:
      '¡Muy rápido! Convertimos tus pesos a dólares en minutos y puedes enviarlos al mundo el mismo día. A destinos como China puede tomar unas horas, pero siempre será más rápido que un banco tradicional.',
  },
  {
    question: '¿Es seguro usar Flowex Pay?',
    answer:
      '¡Totalmente! Guardamos tu información en servidores seguros de Amazon (AWS), protegemos tus fondos con Fireblocks (líder mundial en custodia digital), y usamos Twilio para enviarte códigos de verificación seguros. Tus datos y dinero están en buenas manos.',
  },
  {
    question: '¿Cómo empiezo a usar Flowex Pay?',
    answer:
      '¡Es súper fácil! Regístrate en flowexpay.com, verifica tu identidad (te enviaremos un enlace), y recarga tu cuenta con pesos colombianos vía PSE o desde bancos en EE. UU., Europa o México. Luego, puedes enviar dinero al mundo o abrir una cuenta virtual si la necesitas.',
  },
  {
    question: '¿Cuánto cuesta enviar dinero?',
    answer:
      'Somos más económicos que los bancos, especialmente en transferencias grandes. Agendemos una cita',
  },
  {
    question:
      '¿Cómo recargo mi cuenta de Flowex Pay para enviar dinero a mi broker como Charles Schwab?',
    answer:
      '¡Es muy sencillo! Inicia sesión en flowexpay.com y ve a la sección "Recargar". Puedes recargar con pesos colombianos vía PSE desde un banco en Colombia, o con dólares desde bancos en EE. UU., Europa o México. También aceptamos recargas desde direcciones blockchain, pero estas tienen un costo del 0.3% del monto. Elige tu método, ingresa el monto que necesitas para tu cuenta de corretaje, y sigue las instrucciones. Una vez recargada tu cuenta, tus pesos se convierten a dólares y estarán listos para enviar.',
  },
  {
    question:
      '¿Qué hago después de recargar mi cuenta para enviar dinero a mi cuenta de Charles Schwab?',
    answer:
      'Una vez que recargues tu cuenta en flowexpay.com, ve a la sección "Transferir". Selecciona la opción de enviar dinero a una cuenta bancaria en EE. UU. Ingresa los datos de tu cuenta de Charles Schwab, como el número de cuenta y el routing number (puedes encontrarlos en tu perfil de Schwab). Luego, indica el monto en dólares que deseas enviar. Revisa los detalles, confirma la transacción, y el dinero llegará a tu cuenta de Schwab si es por ACH se demora hasta 3 días, si es por wire se demora un par de horas. ¡Así de fácil!',
  },
  {
    question: '¿Cuánto cuesta enviar dinero a mi cuenta de Charles Schwab?',
    answer:
      'Enviar dinero a EE. UU. con Flowex Pay es más económico que los bancos, que cobran promedio 120 mil pesos por una transferencia. Nuestras tarifas son competitivas, y estamos trabajando para que sean aún más bajas (pronto ajustaremos nuestra tarifa con socios). El costo exacto depende del monto que envíes, pero te mostraremos el detalle antes de confirmar la transacción. dependiendo que sea por wire o ACH',
  },
  {
    question:
      '¿Es seguro enviar dinero desde Flowex Pay a mi cuenta de Charles Schwab?',
    answer:
      '¡Claro que sí! Usamos socios líderes como Amazon (AWS) para guardar tu información, Fireblocks para proteger tus fondos, y Twilio para enviarte códigos de verificación seguros. Cada transferencia está protegida con medidas de seguridad avanzadas, como encriptación y autenticación multifactor, para que tu dinero llegue a tu cuenta de Schwab sin problemas.',
  },
  {
    question: 'No veo el dinero en mi cuenta de Charles Schwab, ¿qué hago?',
    answer:
      'No te preocupes, lo revisaremos. Primero, verifica el estado de tu transferencia en la sección "Historial" de flowexpay.com. Si aparece como completada, puede tomar unos minutos llegar a tu cuenta de Schwab. Recuerda que los pagos por ACH pueden demorar hasta 3 días y si es wire puede tardar hasta 3 horas, en horas  laborales, si transfeires despues de las 5:00PM ya tu dinero llega al otro díaSi han pasado más de 24 horas, dame el número de transacción y lo investigaré con nuestro equipo y socios. Contáctame por WhatsApp si necesitas ayuda urgente.',
  },
  {
    question:
      '¿Puedo enviar dinero a Charles Schwab desde mi cuenta virtual en EE. UU.?',
    answer:
      'Sí, puedes usar tu cuenta virtual en EE. UU. con Flowex Pay para enviar dinero directamente a Charles Schwab. Si aún no tienes una cuenta virtual, nosotros la solicitamos por ti con socios como Lead Bank. Solo ingresa los datos de tu cuenta de Schwab (número de cuenta y routing number), selecciona tu cuenta virtual como origen, y confirma la transferencia. Charles Schwab se demora 1 día habil en hacer llegar el dinero a tu cuenta Flowex de USA',
  },
  {
    question:
      '¿Puedo enviar dinero desde Europa a mi cuenta en Colombia con Flowex Pay?',
    answer:
      '¡Claro que sí! Con Flowex Pay, puedes enviar dinero desde Europa (como España, Francia o Alemania) a tu cuenta en Colombia de manera rápida y económica. Primero, recarga tu cuenta de Flowex Pay desde tu banco en Europa, y luego transfiere el dinero a tu cuenta colombiana en minutos. ¿Quieres saber cómo hacerlo paso a paso?',
  },
  {
    question:
      '¿Cómo recargo mi cuenta de Flowex Pay desde Europa para enviar dinero a Colombia?',
    answer:
      'Inicia sesión en flowexpay.com y ve a "Recargar". Elige la opción de recargar desde un banco en Europa (por ejemplo, España). Te daremos los datos de una cuenta virtual en euros (como un IBAN europeo). Transfiere el monto que deseas desde tu banco europeo a esa cuenta mediante una transferencia SEPA. Una vez que recibamos el dinero, lo convertiremos a dólares y estará listo para enviar a Colombia.',
  },
  {
    question:
      '¿Cómo envío dinero desde Flowex Pay a mi cuenta en Colombia después de recargar desde Europa?',
    answer:
      'Después de recargar, ve a "Transferir" en flowexpay.com. Selecciona enviar dinero a una cuenta bancaria en Colombia e ingresa los datos de tu cuenta (por ejemplo, Bancolombia: número de cuenta y tipo). Indica el monto en dólares que deseas enviar, revisa los detalles, y confirma la transacción. El dinero llegará a tu cuenta en Colombia en minutos, convertido a pesos colombianos.',
  },
  {
    question:
      '¿Cuánto cuesta enviar dinero desde Europa a Colombia con Flowex Pay?',
    answer:
      'Es más económico que los bancos, que cobran $60 por transferencias de $60,000. Si envías 1,000 euros desde Europa, los convertimos a dólares y los enviamos a Colombia con una tarifa competitiva (pronto ajustaremos a 0.7%). Por ejemplo, con una tarifa de 1%, serían $10 por 1,000 dólares. Te mostramos el costo exacto antes de confirmar.',
  },
  {
    question:
      'Envié dinero desde Europa, pero no lo veo en mi cuenta en Colombia, ¿qué hago?',
    answer:
      'No te preocupes, revisemos juntos. Verifica el estado de tu transferencia en "Historial" en flowexpay.com. Si aparece como completada, debería llegar a tu cuenta en Colombia en minutos. Si han pasado más de 24 horas, dame el número de transacción y lo investigaré con nuestro equipo y socios. Contáctame por WhatsApp si necesitas ayuda urgente.',
  },
  {
    question: '¿Puedo enviar dinero desde México a Colombia con Flowex Pay?',
    answer:
      '¡Claro! Con Flowex Pay, puedes enviar dinero desde México a Colombia de forma rápida y económica. Recarga tu cuenta desde un banco mexicano, y luego transfiere el dinero a una cuenta en Colombia en minutos. ¿Quieres saber cómo hacerlo paso a paso?',
  },
  {
    question:
      '¿Cómo recargo mi cuenta de Flowex Pay desde México para enviar dinero a Colombia?',
    answer:
      'nicia sesión en flowexpay.com y ve a "Recargar". Elige la opción de recargar desde un banco en México. Te daremos los datos de una cuenta virtual en pesos mexicanos. Transfiere el monto que deseas desde tu banco mexicano (por ejemplo, Banorte) a esa cuenta mediante SPEI. Una vez que recibamos el dinero, lo convertiremos a dólares y estará listo para enviar a Colombia.',
  },
  {
    question:
      '¿Cómo envío dinero desde Flowex Pay a una cuenta en Colombia después de recargar desde México?',
    answer:
      'Después de recargar, ve a "Transferir" en flowexpay.com. Selecciona enviar dinero a una cuenta bancaria en Colombia e ingresa los datos de la cuenta (por ejemplo, Bancolombia: número de cuenta y tipo). Indica el monto en dólares, revisa los detalles, y confirma la transacción. El dinero llegará a la cuenta en Colombia en minutos, convertido a pesos colombianos.',
  },
  {
    question: '¿Puedo recibir dinero en México desde Colombia con Flowex Pay?',
    answer:
      '¡Sí! Con Flowex Pay, puedes recibir dinero en México desde Colombia de manera rápida. Recarga tu cuenta con pesos colombianos, y luego transfiere el dinero a tu cuenta bancaria en México (por ejemplo, BBVA México) en minutos. ¿Te ayudo con los pasos?',
  },
  {
    question: '¿Cómo recibo dinero en México desde Colombia con Flowex Pay?',
    answer:
      'Primero, recarga tu cuenta en flowexpay.com con pesos colombianos vía PSE desde un banco en Colombia (como Davivienda). Luego, ve a "Transferir", selecciona enviar dinero a una cuenta bancaria en México, e ingresa los datos de tu cuenta (como el número de cuenta y CLABE de BBVA México). Indica el monto en dólares, y nosotros lo convertiremos a pesos mexicanos. El dinero llegará en minutos.',
  },
  {
    question:
      '¿Cuánto cuesta enviar o recibir dinero desde México con Flowex Pay?',
    answer:
      'Es más económico que los bancos, que cobran $60 por transferencias de $60,000. Si envías 1,000 dólares desde México (o recibes en México desde Colombia), nuestra tarifa es competitiva, el costo de traer desde tu cuenta de Mexico a Colombia es de 2 dolares no mas',
  },
  {
    question: 'Envié dinero a México, pero no ha llegado, ¿qué hago?',
    answer:
      'No te preocupes, lo revisaremos. Verifica el estado en "Historial" en flowexpay.com. Si aparece como completada, debería llegar a tu cuenta en México en minutos. Si han pasado más de 24 horas, dame el número de transacción y lo investigaré con nuestro equipo y socios. Contáctame por WhatsApp si necesitas ayuda urgente.',
  },
  {
    question:
      '¿Qué información debo dar para enviar dinero al Banco de la República con Flowex Pay?',
    answer:
      'Para enviar dinero al Banco de la República con Flowex Pay, necesitas proporcionar el motivo de la transferencia (por ejemplo, pago de impuestos o una operación de cambio), los datos de tu cuenta de origen (como tu cuenta en Bancolombia), y el monto exacto en pesos colombianos o dólares. También te pediremos tu identificación (cédula o NIT si eres empresa) y una breve descripción del propósito de la operación, ya que el Banco de la República lo exige para cumplir con las normativas de transferencias internacionales. Todo esto lo puedes ingresar en la sección "Transferir" de flowexpay.com.',
  },
  {
    question:
      '¿Por qué necesito dar el motivo de mi transferencia al Banco de la República?',
    answer:
      'El Banco de la República regula todas las operaciones de cambio en Colombia, y por eso pide el motivo de la transferencia. Esto ayuda a garantizar que el dinero se use de forma legal y transparente, como para pagos de impuestos, operaciones comerciales o transferencias autorizadas. Cuando hagas la transferencia en flowexpay.com, solo selecciona el motivo (por ejemplo, "pago de impuestos") y describe brevemente el propósito. ¡Nosotros nos encargamos del resto!',
  },
  {
    question:
      '¿Qué datos de mi cuenta debo dar para una transferencia al Banco de la República?',
    answer:
      'Necesitas dar el número de tu cuenta bancaria de origen (por ejemplo, tu cuenta en Bancolombia), el nombre del titular (debe coincidir con tu registro en Flowex Pay), y el tipo de cuenta (ahorros o corriente). También te pediremos tu identificación (cédula o NIT si eres empresa) para cumplir con las normas del Banco de la República. Ingresa estos datos en la sección "Transferir" de flowexpay.com, y nosotros nos encargamos de procesar la operación',
  },
  {
    question:
      '¿Cómo puede mi empresa enviar pagos a proveedores en el exterior con Flowex Pay?',
    answer:
      '¡Es muy fácil! Registra tu empresa en flowexpay.com y verifica tu identidad con nuestro enlace de KYB (necesitarás datos como el NIT y el representante legal). Luego, recarga tu cuenta con pesos colombianos vía PSE o desde bancos en EE. UU., Europa o México. Una vez recargada, ve a "Transferir", selecciona el destino (por ejemplo, EE. UU., China o Europa), e ingresa los datos de la cuenta de tu proveedor (como número de cuenta y routing number o IBAN). El dinero llega en minutos, y es más económico que los bancos.',
  },
  {
    question:
      '¿Qué información necesita mi empresa para recibir pagos del exterior?',
    answer:
      'Para recibir pagos del exterior, tu empresa debe estar registrada en flowexpay.com y haber pasado la verificación KYB. Luego, puedes usar una cuenta virtual en EE. UU., Europa o México para recibir dinero directamente. Proporciona a tus clientes los datos de tu cuenta virtual (como un número de cuenta y routing number en EE. UU., o un IBAN en Europa). Una vez que recibamos el dinero, lo convertimos a dólares y lo depositamos en tu cuenta de Flowex Pay, listo para transferir a tu banco en Colombia o usar para otros pagos.',
  },
  {
    question:
      '¿Cuánto cuesta a mi empresa enviar dinero al exterior con Flowex Pay?',
    answer:
      'Nuestra tarifa es competitiva. Te mostramos el costo exacto antes de confirmar la transacción. Además, no cobramos por recibir dinero en nuestras cuentas virtuales.',
  },
  {
    question:
      '¿Es seguro para mi empresa usar Flowex Pay para transferencias internacionales?',
    answer:
      '¡Totalmente! Usamos socios líderes como Amazon (AWS) para guardar tu información, Fireblocks para proteger tus fondos, y Twilio para enviarte códigos de verificación seguros. Cada transferencia está protegida con encriptación y autenticación multifactor. También cumplimos con las normativas del Banco de la República y la UIAF para garantizar operaciones legales y transparentes.',
  },
  {
    question:
      '¿Cómo puede mi empresa abrir una cuenta virtual en EE. UU. o Europa para pagar o recibir dinero?',
    answer:
      'Tu empresa puede usar una cuenta virtual en EE. UU., Europa o México para pagar o recibir dinero directamente. Estas cuentas no se crean automáticamente para evitar costos innecesarios. Si la necesitas, regístrate en flowexpay.com, verifica tu empresa con KYB, y nosotros la solicitamos por ti con socios como Lead Bank. Una vez creada, te daremos los datos (como número de cuenta y routing number o IBAN) para que puedas usarla.',
  },
  {
    question:
      '¿Puede mi empresa ganar recompensas con el dinero en Flowex Pay?',
    answer:
      'Sí, tu empresa puede elegir prestar sus dólares en plataformas seguras como Kamino para ganar recompensas. Por ejemplo, podrías ganar un interés variable (alrededor del 4.8% anual), pero estas recompensas no están garantizadas y dependen del mercado. Te explicaremos todo para que tomes la mejor decisión para tu negocio',
  },
  {
    question:
      '¿Qué hago si una transferencia de mi empresa no llega al destino?',
    answer:
      'No te preocupes, lo revisaremos juntos. Verifica el estado en "Historial" en flowexpay.com. Si aparece como completada, debería llegar al destino en minutos (o hasta 1 día si es China). Si han pasado más de 24 horas, dame el número de transacción, el NIT de tu empresa, y el destino (por ejemplo, EE. UU.), y lo investigaré con nuestro equipo y socios. Contáctame por WhatsApp si necesitas ayuda urgente.',
  },
  {
    question:
      '¿Qué información necesita mi empresa para cumplir con las normativas del Banco de la República?',
    answer:
      'Para cumplir con las normativas del Banco de la República, tu empresa debe proporcionar el motivo de la transferencia (por ejemplo, pago a proveedores o importaciones), el NIT, y los datos de la cuenta de origen y destino (como número de cuenta y tipo). También te pediremos el nombre del representante legal y una breve descripción del propósito. Todo esto lo puedes ingresar en "Transferir" en flowexpay.com, y nosotros nos encargamos de reportarlo correctamente.',
  },
];

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="relative">
      <HeaderWithoutMenu />

      <section className="bg-[linear-gradient(to_bottom,rgba(0,0,0,0)_0%,#E7EFFF_100%)] pt-4">
        <div className="px-2.5">
          <div className="relative rounded-[10px]">
            <img
              src={FaqImage}
              alt="Background Image"
              className="w-full h-[350px] rounded-[20px] object-cover"
            />

            <div className="absolute inset-0">
              <div className="px-8 sm:px-16 pt-62 sm:pt-54 md:pt-50 lg:pt-40">
                <div className="w-full md:w-155 space-y-2">
                  <p className="font-[poppins] text-[22px] sm:text-[32px] md:text-[40px] lg:text-[56px] text-white font-semibold leading-[1.1] tracking-[-1px]">
                    Preguntas frecuentes
                  </p>
                  <p className="font-[poppins] text-sm sm:text-base md:text-lg lg:text-[22px] text-white font-semibold leading-[1.45]">
                    Respondemos lo que más quieren saber nuestros usuarios sobre
                    Flowex Pay
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="px-10 sm:px-20 py-10">
          {Faqs.map((item, idx) => (
            <div
              key={idx}
              className={`${idx < 40 ? 'border-b-3 border-b-[#CDD9F0]' : ''} `}
            >
              <FaqItem key={idx} {...item} />
            </div>
          ))}
        </div>

        <div className="w-full h-4"></div>
      </section>

      <WhatsApp />

      <Footer />
    </div>
  );
}
